import { PosAbsolute, PosRelative } from '@layout/BuildingBlocks'
import React from 'react'

export const ESGIcon = ({
  size = 32,
  width,
  iconColor = '#4C4D4C',
  backgroundColor = '#C9DDA1',
  strokeWidth,
  shadow = true,
}) => {
  return (
    <PosRelative width={width || size} height="100%">
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="16.5" cy="12.5" r="12.5" fill={backgroundColor} />
        </svg>
      </PosAbsolute>
      <PosAbsolute>
        <svg
          width={width || size}
          height="100%"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          style={{ filter: shadow && 'drop-shadow(0 5px 3px #bfbfbf)' }}
        >
          <path
            d="M22.9776 10.0483C22.8651 8.40715 22.1338 6.86989 20.9315 5.74717C19.7292 4.62445 18.1455 4 16.5005 4C14.8555 4 13.2718 4.62445 12.0695 5.74717C10.8672 6.86989 10.1359 8.40715 10.0234 10.0483C7.26 10.0616 6 12.3607 6 14.5C6.02778 15.1256 6.17976 15.7393 6.44708 16.3056C6.7144 16.8718 7.09172 17.3792 7.55706 17.7982C8.02241 18.2172 8.56647 18.5395 9.15756 18.7461C9.74865 18.9528 10.375 19.0398 11 19.002H16V22.002H12.153C12.0097 22.002 11.8681 22.0328 11.7378 22.0923C11.6074 22.1518 11.4914 22.2386 11.3975 22.3468C11.3036 22.4551 11.2341 22.5822 11.1936 22.7197C11.1532 22.8571 11.1427 23.0017 11.163 23.1435L11.816 27.7142C11.8672 28.0716 12.0455 28.3985 12.3183 28.6349C12.5911 28.8714 12.94 29.0015 13.301 29.0015H19.699C20.0601 29.0015 20.409 28.8713 20.6818 28.6347C20.9545 28.3981 21.1328 28.0711 21.1839 27.7137L21.8369 23.143C21.8572 23.0012 21.8467 22.8566 21.8063 22.7192C21.7658 22.5817 21.6963 22.4546 21.6024 22.3463C21.5085 22.2381 21.3925 22.1513 21.2621 22.0918C21.1318 22.0323 20.9902 22.0015 20.8469 22.0015H17V19.0015H22C22.625 19.0393 23.2513 18.9523 23.8423 18.7457C24.4334 18.539 24.9774 18.2169 25.4428 17.7979C25.9081 17.379 26.2854 16.8716 26.5528 16.3054C26.8201 15.7392 26.9722 15.1255 27 14.5C27 12.3608 25.74 10.062 22.9776 10.0483ZM20.847 23.0015L20.194 27.5723C20.1765 27.6912 20.1169 27.7999 20.0261 27.8787C19.9352 27.9574 19.8192 28.001 19.699 28.0015H13.301C13.1808 28.001 13.0648 27.9574 12.9739 27.8787C12.8831 27.7999 12.8235 27.6912 12.806 27.5723L12.153 23.0015H20.847ZM22 18.0015H11C9.0337 18.0015 7 16.6915 7 14.4995C7 12.8354 7.9531 11.0454 10.0459 11.0454C10.7622 10.9835 11.4741 11.2065 12.0271 11.666C12.5801 12.1255 12.9297 12.7845 13 13.5C13 13.6326 13.0527 13.7598 13.1464 13.8536C13.2402 13.9473 13.3674 14 13.5 14C13.6326 14 13.7598 13.9473 13.8536 13.8536C13.9473 13.7598 14 13.6326 14 13.5C13.9535 12.6877 13.6335 11.9151 13.0921 11.3078C12.5506 10.7006 11.8196 10.2944 11.0179 10.1555C11.1037 8.75967 11.7187 7.44913 12.7374 6.49109C13.7562 5.53304 15.102 4.99964 16.5005 4.99964C17.8989 4.99964 19.2447 5.53304 20.2635 6.49109C21.2822 7.44913 21.8972 8.75967 21.983 10.1555C21.1812 10.2943 20.45 10.7004 19.9084 11.3076C19.3667 11.9149 19.0466 12.6876 19 13.5C19 13.6326 19.0527 13.7598 19.1464 13.8536C19.2402 13.9473 19.3674 14 19.5 14C19.6326 14 19.7598 13.9473 19.8536 13.8536C19.9473 13.7598 20 13.6326 20 13.5C20.0705 12.7845 20.4201 12.1257 20.9731 11.6663C21.5261 11.2069 22.2379 10.984 22.9541 11.0459C25.0474 11.0459 26 12.8359 26 14.5C26 16.6924 23.9663 18.002 22 18.002V18.0015Z"
            fill={iconColor}
            stroke={iconColor}
            strokeWidth={strokeWidth}
          />
        </svg>
      </PosAbsolute>
    </PosRelative>
  )
}
